<template>
  <v-app-bar
    app
    clipped-left
    elevation="1"
    color="primary"
    style="border-bottom: 1px solid rgba(255, 255, 255, 0.12); color: #fff;"
  >
    <v-app-bar-nav-icon
      v-if="!isDesktop"
      @click.stop="toggleDrawer"
    ></v-app-bar-nav-icon>
    <v-toolbar-title><b>Bytewood</b> <span style="color: #303030;"> Desk</span></v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn
      icon
      @click="changeTheme"
    >
      <v-icon
        v-if="theme"
        color="white"
      >mdi-weather-sunny</v-icon>
      <v-icon
        v-else
        color="white"
      >mdi-weather-night</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    methods: {
      ...mapActions([
        'changeTheme',
        'toggleDrawer'
      ])
    },
    computed: {
      ...mapGetters(['theme', 'isDesktop'])
    },
    watch: {
      theme: {
        handler(val) {
          this.$vuetify.theme.dark = val
        },
        immediate: true
      }
    }
  }
</script>

<style>
</style>
